import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main.component';
import { documentRoutes } from '../features/document/document-routing.module';
import { LoginComponent } from '../login/login.component';
import { AuthGuard } from '../auth-guard.service';
import { reportRoutes } from '../features/report/report-routing.module';
import { searchRoutes } from '../features/search/search-routing.module';
import { saleTaxRoutes } from '../features/saletax/saletax-routing.module';
import { profileRoutes } from '../features/profile/profile-routing.module';
import { dashboardRoutes } from '../features/dashboard/dashboard-routing.module';
import { billingRoutes } from '../features/billing/billing-routing.module';
import {taxReportRoutes} from "../features/tax-report/tax-report-routing.module";
import {zipFileRoutes} from "../features/zip-file/zip-file-routing.module";
import {ValidateOtpComponent} from "../validate-otp/validate-otp.component";
import {LoginAdminComponent} from "../login-admin/login-admin.component";
import {taxB2PRoutes} from '../features/tax-b2p/tax-b2p-routing.module';
import {bulktaxReportRoutes} from "../features/bulk-tax-report/bulk-tax-report-routing.module";
import {emailDashboardroutes} from "../features/email-dashboard/email-dashboard-routing.module";
import {importDataRoutes} from "../features/import-data/import-data-routing.module";

export const mainRoutes: Routes = [

  // for role IT, default page is /dashboard-it
  // for role Accounttant, default page is /taxReport
  // more information is in constructor of file 'dashboard-list.component.ts'
  {path: '', redirectTo: '/dashboard', pathMatch: 'full'},

  {path: 'validate-otp', component: ValidateOtpComponent},
  {path: 'validate-otp/:msg', component: ValidateOtpComponent},
  {path: 'login/:msg', component: LoginComponent},
  {path: 'login-otp', component: LoginComponent},
  {path: 'login', component: LoginAdminComponent},
  {
    path: '',
    component: MainComponent,
    children: [
      ...documentRoutes,
      ...reportRoutes,
      ...searchRoutes,
      ...dashboardRoutes,
      ...billingRoutes,
      ...saleTaxRoutes,
      ...profileRoutes,
      ...taxReportRoutes,
      ...zipFileRoutes,
      ...taxB2PRoutes,
      ...bulktaxReportRoutes,
      ...emailDashboardroutes,
      ...importDataRoutes
    ],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(mainRoutes)],
  exports: [RouterModule]
})
export class MainRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/main/main-routing.module.ts